import React from 'react'
import { Link } from 'react-router-dom'

export default function Button(props) {
  return (
    <Link to={props.to} className='px-8 py-2 bg-primOrange rounded-[19px] text-white font-bold md:px-10 md:py-3 md:text-md hover:bg-gray-700 transition-all duration-200;'>{props.texte}</Link>
  )
}
